import { ArticleDetailFragmentApi, SimpleArticleFragmentApi, useTopMenuArticlesQueryApi } from 'graphql/generated';
import { ArticleBlogDetailType, ArticleDetailType, SimpleArticleType } from 'types/article';
import { SimpleBlogArticleType } from 'types/blogArticle';

export const useTopMenuArticles = (noOfArticles: number): SimpleArticleType[] => {
    const [result] = useTopMenuArticlesQueryApi({ variables: { noOfArticles } });
    const mappedArticles = [];

    if (result.data?.articles.edges !== undefined && result.data.articles.edges !== null) {
        for (const articleEdge of result.data.articles.edges) {
            if (articleEdge?.node !== undefined && articleEdge.node !== null) {
                if (articleEdge.node.__typename === 'ArticleSite') {
                    mappedArticles.push(articleEdge.node);
                } else if ('url' in articleEdge.node && articleEdge.node.url) {
                    mappedArticles.push({
                        ...articleEdge.node,
                        slug: /^(https?:\/\/|www\.)/i.test(articleEdge.node.url)
                            ? articleEdge.node.url
                            : `/${articleEdge.node.url.replace(/^\/+/, '')}`,
                    });
                }
            }
        }
    }

    return mappedArticles;
};
export const mapArticleDetail = (apiData: ArticleDetailFragmentApi): ArticleDetailType | ArticleBlogDetailType => {
    return {
        ...apiData,
        __typename: 'Article',
        text: Array.isArray(apiData.text) ? apiData.text.join('') : apiData.text,
    };
};

export const mapSimpleArticle = (apiData: SimpleArticleFragmentApi): SimpleArticleType | SimpleBlogArticleType => {
    return {
        ...apiData,
    };
};
